module.exports = __webpack_public_path__ + "img/bn0719.0af1c80b.png";